import React from 'react';
import { Range } from 'react-range';

import { displayNumber } from '../../../helpers/numberHelpers';
import InputValue from './InputValue';

const ValueOnSideRangeSlider = ({ description, currentValue, onChange, min, max, step, sliderStep, disabled, precision, ...props }) => (
    <div className="range-slider-container">
        <div className="range-slider">
            <NormalRangeSlider description={description} currentValue={currentValue} min={min} max={max} step={step} sliderStep={sliderStep} disabled={disabled} {...props} hideValues />
        </div>
        <div className="slider-value">
            <InputValue min={min} max={max} onChange={onChange} value={displayNumber(currentValue, precision || 0)} description={description} disabled={disabled} precision={precision} step={step} />
        </div>
    </div>
);

const NormalRangeSlider = ({ min, changed, max, step, sliderStep, currentValue, onChange, disabled, background, hideValues, description, minDisplay, maxDisplay, precision, ...props }) => (
    <div className={`slider${disabled ? ' slider-disabled' : ''}`} {...props}>
        <Range
            step={sliderStep || step}
            min={min}
            max={max}
            values={[currentValue]}
            onChange={changed}
            disabled={disabled}
            renderTrack={({ props, children }) => (
                <div
                    {...props}
                    style={{
                        ...props.style,
                        background
                    }}
                    className="slider-rail"
                >
                    {children}
                </div>
            )}
            renderThumb={({ props }) => (
                <div
                    {...props}
                    style={{
                        ...props.style,
                        zIndex: 2
                    }}
                    className="slider-handle"
                >
                    <div className="slider-handle-inner" />
                </div>
            )}
        />
        {!hideValues && (
            <div className="slider-values">
                <div className="slider-min">{minDisplay || min}</div>
                <div className="slider-value">
                    <InputValue min={min} max={max} onChange={onChange} value={displayNumber(currentValue, precision || 0)} description={description} precision={precision} step={step} />
                </div>
                <div className="slider-max">{maxDisplay || max}</div>
            </div>
        )}
    </div>
);

export default function RangeSlider({ min, max, step, sliderStep, currentValue, onChange, disabled, background, hideValues, description, minDisplay, maxDisplay, valueOnSide, ...props }) {
    const changed = values => {
        onChange(values[0]);
    };

    if (valueOnSide) {
        return (
            <ValueOnSideRangeSlider
                changed={changed}
                min={min}
                max={max}
                step={step}
                sliderStep={sliderStep}
                currentValue={currentValue}
                onChange={onChange}
                disabled={disabled}
                background={background}
                hideValues={hideValues}
                description={description}
                minDisplay={minDisplay}
                maxDisplay={maxDisplay}
                {...props}
            />
        );
    }

    return (
        <NormalRangeSlider
            changed={changed}
            min={min}
            max={max}
            step={step}
            sliderStep={sliderStep}
            currentValue={currentValue}
            onChange={onChange}
            disabled={disabled}
            background={background}
            hideValues={hideValues}
            description={description}
            minDisplay={minDisplay}
            maxDisplay={maxDisplay}
            {...props}
        />
    );
}
